// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lzN8k","menu":"styles_menu__YmGPr","padding":"styles_padding__7WuOb","box":"styles_box__IyIzd","activeText":"styles_activeText__haJxq"};